import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=31621508&scoped=true&"
import script from "./questionEdit.vue?vue&type=script&lang=js&"
export * from "./questionEdit.vue?vue&type=script&lang=js&"
import style1 from "./questionEdit.vue?vue&type=style&index=1&id=31621508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31621508",
  null
  
)

export default component.exports